/**
 * @author yangxiaochuan
 * agGrid
 */
import Component from "../../../lib/component";
import template from './agGrid.html';
import Clipboard from 'clipboard';
import msgBox from '../../../lib/msgbox';
import {Grid,GridOptions,gridOptions} from 'ag-grid/main';
import './agGrid.scss';
import 'ag-grid/dist/styles/ag-grid.css';
import 'ag-grid/dist/styles/theme-bootstrap.css';
import 'ag-grid/dist/styles/theme-blue.css';
import 'ag-grid/dist/styles/theme-material.css';
import 'ag-grid/dist/styles/theme-dark.css';
import 'ag-grid/dist/styles/theme-fresh.css';

import {dgcService} from '../../../services/dataGrid/data-table-control.service';

let agGrid = Component.extend({
    template: template,
    data: {
        columnDefs : [],
        rowData : [],
        footerData: [{myfooter: '合计'}],
        cssTheme: 'ag-bootstrap',
        floatingFilter: false,
        //不需要分页
        noFooter: false,
        copyData: '',
        clipboard:'',
        //原始表头数据
        fieldsData: [],
        localeText:{
            copy: '复制',
            ctrlC: 'ctrl + C',
            paste: '粘贴',
            ctrlV: 'ctrl + V',
            noRowsToShow: '<img src='+ require( "../../../assets/images/dataGrid/icon_shuju_no.png" ) +'>'
        },
        onColumnResized:function ($event) {
        },
        onDragStopped:function ($event) {
        },
        onDragStarted:function ($event) {
            if( $('.ag-dnd-ghost-label').html() == 'undefined' ){
                $('.ag-dnd-ghost-label').html('')
            }
            //提高拖动提示的层级使其显示
            setTimeout( ()=>{
                $(".ag-dnd-ghost").css( {'z-index':'999','background':'#ffffff','font-size':'12px','border-radius':'2px','border-color':'rgba(228, 228, 228, 1)'} );
            },0 )
        },
        onSortChanged:function ($event) {
        },
        onCellClicked:function ($event) {
        },
        onRowDoubleClicked:function ($event) {
        },
        onRowSelected:function (param) {
        },
        setRowStyle:function (param) {
        },
        isExternalFilterPresent:function () {
        },
        doesExternalFilterPass:function ($event) {
        },
        rowDataChanged:function ($event) {
        },
        onCellValueChanged:function ($event) {
        }
    },
    gridOptions: GridOptions,
    actions: {
        createGridOptions: function (){
            console.log( "#################" )
            console.log( "#################" )
            console.log( "#################" )
            console.log( $('html').attr('fontsize') )
            this.gridOptions = {
                defaultColDef: {
                    resizable: true,
                },
                columnDefs: this.data.columnDefs,
                rowData: this.data.rowData,
                floatingFilter: this.data.floatingFilter,
                suppressFilterButton: true,
                animateRows: true,
                suppressMultiSort: true,
                enableColResize: true,
                enableSorting: true,
                sortingOrder: ['asc','desc','null'],
                suppressRowClickSelection: true,
                suppressColumnVirtualisation: false,
                rowSelection: 'multiple',
                headerHeight: $('html').attr('fontsize')  == '14px'?38:40,
                rowHeight: $('html').attr('fontsize')  == '14px'?38:40,
                floatingFiltersHeight: 0,
                icons: dgcService.replacingIcons,
                localeText: this.data.localeText,
                // onGridReady: function () {
                //     //表格创建完成后执行的事件
                //     // **************** 调整表格大小自适应 **********************
                //     console.log(gridOptions,'gridOptions');
                //     gridOptions.columnApi.sizeColumnsToFit(); 
                // },
                //列宽改变
                onColumnResized: this.data.onColumnResized,
                //拖动结束
                onDragStopped: this.data.onDragStopped,
                onDragStarted: this.data.onDragStarted,
                onRowDataChanged: this.data.rowDataChanged,
                //双击查看
                onCellClicked: this.data.onCellClicked,
                onCellValueChanged: this.data.onCellValueChanged,
                //外部搜索
                isExternalFilterPresent: this.data.isExternalFilterPresent,
                doesExternalFilterPass: this.data.doesExternalFilterPass,
                //行双击
                onRowDoubleClicked: this.data.onRowDoubleClicked,
                //单元格双击
                onCellDoubleClicked: this.data.onCellDoubleClicked,
                //分组
                getNodeChildDetails: (rowItem)=>{
                    if ( rowItem.group||Object.is(rowItem.group,'')||Object.is(rowItem.group,0) ) {
                        return {
                            group: true,
                            // open C be default
                            // expanded: rowItem.group === 'Group C',
                            // expanded: rowItem.children&&rowItem.children[0]&&rowItem.children[0].group?true:false,
                            expanded: rowItem.children&&rowItem.children[0]&&rowItem.children[0].group?true:false,
                            // provide ag-Grid with the children of this group
                            children: rowItem.children,
                            // this is not used, however it is available to the cellRenderers,
                            // if you provide a custom cellRenderer, you might use it. it's more
                            // relavent if you are doing multi levels of groupings, not just one
                            // as in this example.
                            field: 'group',
                            // the key is used by the default group cellRenderer
                            key: rowItem.group
                        };
                    } else {
                        return {
                            group: false
                        };
                    }
                },
                //排序
                onSortChanged: this.data.onSortChanged,
                //行选择
                onRowSelected: this.data.onRowSelected,
                //单元格双击
                onCellDoubleClicked: this.data.onCellDoubleClicked,
                //设置颜色
                getRowStyle: (param)=>{
                    return this.data.setRowStyle( param )
                }
            };
            //是否需要footer
            if( !this.data.noFooter ){
                this.gridOptions['pinnedBottomRowData'] = this.data.footerData;
            }
        },
        createAgGrid: function (){
            let eGridDiv = this.el.find( '#myGrid' );
            let mygrid = new Grid( eGridDiv[0] , this.gridOptions );
        },
        //重新赋值
        setGridData: function ( json ,penetrate_obj) {
            if( json.columnDefs ){
                this.data.columnDefs = json.columnDefs;
                this.gridOptions.api.setColumnDefs( json.columnDefs );
            }
	        if( json.rowData ){
		        for(let k in json.rowData){
			        if(!$.isEmptyObject(penetrate_obj)){
				        for(let id in penetrate_obj){
					        if(json.rowData[k].hasOwnProperty(id)){
						        json.rowData[k][id]=penetrate_obj[id];
					        }
				        }
			        }
		        }
		        this.data.rowData = json.rowData;
		        this.gridOptions.api.setRowData( json.rowData );
	        }
            if( json.footerData ){
                this.data.footerData = json.footerData;
                this.gridOptions.api.setPinnedBottomRowData( json.footerData );
            }
        },
        //宽度自适应
        autoWidth: function () {
            let arr = [];
            for( let d of this.data.fieldsData ){
                let no = ['group','mySelectAll','number'];
                if( no.indexOf( d.field ) == -1 ){
                    arr.push( d.field);
                }
            }
            this.gridOptions.columnApi.autoSizeColumns( arr );
        },
        //刷新序号
        refreshView: function () {
            this.gridOptions.api.redrawRows();
        },
        //渲染右键菜单
        renderMenu: function () {

            setTimeout(()=>{

                this.el && this.el.find('.ag-root').on('contextmenu',(e)=>{
                    this.data.copyData = e.target.innerText;
                    let menu = this.el.find('#myGrid-menu')[0];
                    //鼠标点的坐标
                    let oX = e.clientX;
                    let oY = e.clientY;
                    //判断不同大小弹窗,菜单出现的位置
                    // if(e.currentTarget.clientWidth =="1353"){
                    //     menu.style.left = oX - 283.5 + "px";
                    //     menu.style.top = oY - 150 + "px";
                    // }else if (e.currentTarget.clientWidth =="1179") {
                    //     menu.style.left = oX - 370.5 + "px";
                    //     menu.style.top = oY - 210 + "px";
                    // }else {
                    //     if (e.currentTarget.clientHeight>717) {
                    //         menu.style.left = oX + "px";
                    //         menu.style.top = oY - 40 + "px";
                    //     }else {
                    //         menu.style.left = oX + "px";
                    //         menu.style.top = oY -80 + "px";
                    //     }
                    //
                    //
                    // }
                    menu.style.left = oX + 10 + "px";
                    menu.style.top = oY + 10 + "px";
                    menu.style.display = "block";
                    return false;
                })
                this.el && this.el.find('.ag-root').on('click',(e)=>{
                    let menu = this.el.find('#myGrid-menu')[0]
                    if(menu.style.display == 'block'){
                        menu.style.display = 'none';
                    }
                })


            },1000)

            let That = this;
            let clipboard = new Clipboard('#menu-copy', {
                text: (trigger) => {
                    return That.data.copyData;
                }
            });
            this.data.clipboard=clipboard;
            clipboard.on('success', (e)=> {
            });
            clipboard.on('error', function(e) {
                e.clearSelection();
            });
        },
        //提示信息
        promptMessage (){
            setTimeout(()=>{
                let _that = this;
                if (this.el) {
                    this.el.find('#myGrid').on('mouseover','.ag-cell',(e)=>{
                        if (this.el.find(e.currentTarget).find('a.ag-text-style').length !== 1) {
                            this.data.myTitle = this.el.find(e.currentTarget).attr('title');
                            if (this.data.myTitle !== '' && this.data.myTitle) {
                                let menu = _that.el.find('#myGrid-title')[0];
                                //鼠标点的坐标
                                let oX = e.clientX;
                                let oY = e.clientY;
                                //菜单出现后的位置
                                menu.style.display = "block";
                                menu.style.left = oX + "px";
                                menu.style.top = oY + 20  + "px";
                                _that.el.find('#myGrid-title').html(this.data.myTitle);
                                this.el.find(e.currentTarget).attr('title','');
                            }
                        } else {
                            _that.el.find('#myGrid-title').hide();
                            this.data.myTitle = '';
                        }
                        return false;
                    }).on('mouseout','.ag-cell',(e) => {
                        if (this.data.myTitle !== '' && this.data.myTitle) {
                            this.el.find(e.currentTarget).attr('title', this.data.myTitle);
                        }
                        _that.el.find('#myGrid-title').html('');
                        _that.el.find('#myGrid-title').hide();//移除
                    }).on('mousemove','.ag-cell',(e) => {
                        if (this.el.find(e.currentTarget).find('a.ag-text-style').length !== 1) {
                            if (this.data.myTitle !== '' && this.data.myTitle) {
                                let menu = _that.el.find('#myGrid-title')[0];
                                //鼠标点的坐标
                                let oX = e.clientX;
                                let oY = e.clientY;
                                //菜单出现后的位置
                                menu.style.display = "block";
                                menu.style.left = oX + "px";
                                menu.style.top = oY + 20  + "px";
                            }
                        } else {
                            _that.el.find('#myGrid-title').hide();
                        }
                    })
                }
            },1000)
        }
    },
    binds: [
        {
            event: 'click',
            selector: '#menu-copy',
            callback: function (event) {
                let menu = this.el.find('#myGrid-menu')[0];
                menu.style.display = 'none';
            }
        },
        // {
        //     event: 'click',
        //     selector: '.ag-cell',
        //     callback: function (event) {
        //         this.data.copyData = $(event).attr('title');
        //         return false;
        //     }
        // },
    ],
    afterRender: function (){
        this.actions.createGridOptions();
        this.actions.createAgGrid();
        this.actions.renderMenu();
        if (!window.config.openMessageDialog) {
            this.actions.promptMessage();
        }
    },
    beforeDestory:function () {
        this.data.clipboard.destroy();
    }
});
// class agGrid extends Component {
//     constructor(data,newConfig){
//         for (let d in data) {
//             config.data[d] = data[d];
//         }
//         super($.extend(true,{},config,newConfig,{data:data||{}}));
//     }
// }

export default agGrid;


// WEBPACK FOOTER //
// app/components/dataGrid/agGrid/agGrid.js